import { css } from "@emotion/react";

export const globalColorCss = css`
	:root {
		--primary: #387cf6;
		--card-bg: #272d3c;
		--desc-gray: #808da3;
		--bg-white: #f8f9fb;
		--primary-darken: #2858b6;
		--primary-dark: #20252e;
		--secondary: #1c212d;
		--secondary-dark: #212121;
		--secondary-light: #373b42;
		--bg: #121212;
		--gray-blue: #3f659e;

		--white-darken: rgba(255, 255, 255, 0.7);
		--gray-darken: #7d7d7d;
		--disable: #373b42;

		--font-large: 20px;
	}

	.row-center-center {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		flex-wrap: wrap;
	}

	.row-center-start {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: flex-start;
		flex-wrap: wrap;
	}

	.row-center-end {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: flex-end;
		flex-wrap: wrap;
	}

	.row-center-between {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		flex-wrap: wrap;
	}

	.row-start-center {
		display: flex;
		flex-direction: row;
		align-items: flex-start;
		justify-content: center;
		flex-wrap: wrap;
	}

	.row-start-start {
		display: flex;
		flex-direction: row;
		align-items: flex-start;
		justify-content: flex-start;
		flex-wrap: wrap;
	}

	.row-start-end {
		display: flex;
		flex-direction: row;
		align-items: flex-start;
		justify-content: flex-end;
		flex-wrap: wrap;
	}

	.row-start-between {
		display: flex;
		flex-direction: row;
		align-items: flex-start;
		justify-content: space-between;
		flex-wrap: wrap;
	}

	.row-end-center {
		display: flex;
		flex-direction: row;
		align-items: flex-end;
		justify-content: center;
		flex-wrap: wrap;
	}

	.row-end-start {
		display: flex;
		flex-direction: row;
		align-items: flex-end;
		justify-content: flex-start;
		flex-wrap: wrap;
	}

	.row-end-end {
		display: flex;
		flex-direction: row;
		align-items: flex-end;
		justify-content: flex-end;
		flex-wrap: wrap;
	}

	.row-end-between {
		display: flex;
		flex-direction: row;
		align-items: flex-end;
		justify-content: space-between;
		flex-wrap: wrap;
	}

	.column-center-center {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		flex-wrap: wrap;
	}

	.column-center-start {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: flex-start;
		flex-wrap: wrap;
	}

	.column-center-end {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: flex-end;
		flex-wrap: wrap;
	}

	.column-center-between {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: space-between;
		flex-wrap: wrap;
	}

	.column-start-center {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		justify-content: center;
		flex-wrap: wrap;
	}

	.column-start-start {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		justify-content: flex-start;
		flex-wrap: wrap;
	}

	.column-start-end {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		justify-content: flex-end;
		flex-wrap: wrap;
	}

	.column-start-between {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		justify-content: space-between;
		flex-wrap: wrap;
	}

	.column-end-center {
		display: flex;
		flex-direction: column;
		align-items: flex-end;
		justify-content: center;
		flex-wrap: wrap;
	}

	.column-end-start {
		display: flex;
		flex-direction: column;
		align-items: flex-end;
		justify-content: flex-start;
		flex-wrap: wrap;
	}

	.column-end-end {
		display: flex;
		flex-direction: column;
		align-items: flex-end;
		justify-content: flex-end;
		flex-wrap: wrap;
	}

	.column-end-between {
		display: flex;
		flex-direction: column;
		align-items: flex-end;
		justify-content: space-between;
		flex-wrap: wrap;
	}

	.sendbird-separator .sendbird-separator__text {
		flex-shrink: 0;
		flex-grow: 1;
	}

	* {
		box-sizing: border-box;
		font-family: "Pretendard", "Open Sans", sans-serif, "FontAwesome" !important;
		word-break: break-all;
		white-space: pre-wrap;
	}

	@media screen and (max-width: 900px) {
		.pc {
			display: none !important;
		}
	}

	@media screen and (min-width: 900px) {
		.mobile {
			display: none !important;
		}
	}

	html,
	body {
		padding: 0;
		margin: 0;
		font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell,
			Fira Sans, Droid Sans, Helvetica Neue, sans-serif;
	}

	body {
		white-space: initial;
		line-height: 120%;
		letter-spacing: -1.6px;
	}

	.full-height {
		height: 100vh;
		max-height: -webkit-fill-available;
	}

	a {
		color: inherit;
		text-decoration: none;
	}

	.white-space {
		white-space: pre-wrap;
	}

	.btnc {
		-webkit-transform: perspective(1px) translateZ(0);
		transform: perspective(1px) translateZ(0);
		/* box-shadow: 0 0 1px rgba(0, 0, 0, 0); */
		-webkit-transition-duration: 0.2s;
		transition-duration: 0.2s;
		-webkit-transition-property: transform;
		transition-property: transform;
		-webkit-transition-timing-function: ease-out;
		transition-timing-function: ease-out;
		cursor: pointer;
	}

	.btnc:disabled {
		opacity: 0.2;
		pointer-events: none;
	}

	.btnc:hover,
	.btnc:active,
	.btnc:focus {
		opacity: 0.9;
		-webkit-transform: translateY(-2px);
		transform: translateY(-2px);
	}

	.player-wrapper {
		display: flex;
		flex-direction: center;
		justify-content: center;
	}

	.MuiPickersPopper-root {
		z-index: 99999999 !important;
	}

	/* 한글 폰트 (포맷 확인 잘할 것) */
	@font-face {
		font-family: "Pretendard";
		font-style: normal;
		font-weight: 900;
		src: url("/onepoint/assets/font/pretendard/Pretendard-Black.woff") format("woff");
	}

	@font-face {
		font-family: "Pretendard";
		font-style: normal;
		font-weight: 800;
		src: url("/onepoint/assets/font/pretendard/Pretendard-ExtraBold.woff") format("woff");
	}

	@font-face {
		font-family: "Pretendard";
		font-style: normal;
		font-weight: 700;
		src: url("/onepoint/assets/font/pretendard/Pretendard-Bold.woff") format("woff");
	}

	@font-face {
		font-family: "Pretendard";
		font-style: normal;
		font-weight: 600;
		src: url("/onepoint/assets/font/pretendard/Pretendard-SemiBold.woff") format("woff");
	}

	@font-face {
		font-family: "Pretendard";
		font-style: normal;
		font-weight: 500;
		src: url("/onepoint/assets/font/pretendard/Pretendard-Medium.woff") format("woff");
	}

	@font-face {
		font-family: "Pretendard";
		font-style: normal;
		font-weight: 400;
		src: url("/onepoint/assets/font/pretendard/Pretendard-Regular.woff") format("woff");
	}

	@font-face {
		font-family: "Pretendard";
		font-style: normal;
		font-weight: 300;
		src: url("/onepoint/assets/font/pretendard/Pretendard-Light.woff") format("woff");
	}

	@font-face {
		font-family: "Pretendard";
		font-style: normal;
		font-weight: 200;
		src: url("/onepoint/assets/font/pretendard/Pretendard-ExtraLight.woff") format("woff");
	}

	@font-face {
		font-family: "Pretendard";
		font-style: normal;
		font-weight: 100;
		src: url("/onepoint/assets/font/pretendard/Pretendard-Thin.woff") format("woff");
	}
	/* html {
  font-size: 125%;
     -webkit-text-size-adjust:none; 
}

@media screen and (min-device-width: 320px) {
  html {
    font-size: 62.5%;
  }
}

@media screen and (min-device-width: 360px) {
  html {
    font-size: 70.3125%;
  }
}

@media screen and (min-device-width: 375px) {
  html {
    font-size: 73.2421%;
  }
}

@media screen and (min-device-width: 412px) {
  html {
    font-size: 80.4688%;
  }
}

@media screen and (min-device-width: 414px) {
  html {
    font-size: 80.8594%;
  }
}

@media screen and (min-device-width: 640px) {
  html {
    font-size: 125%;
  }
}

@media screen and (min-device-width: 780px) {
  html {
    font-size: 150%;
  }
}

@media screen and (min-device-width: 1000px) {
  html {
    font-size: 200%;
  }
} */
`;
